module.exports = __webpack_public_path__ + "img/DistributionAPR.930ad93a.svg";